import Configuration from "./configuration"
import { range } from "../helpers/array_helper.js"

const global = new Configuration({
  attachmentTagName: "action-text-attachment",
  attachmentContentTypeNamespace: "actiontext",
  authenticatedUploads: false,
  extensions: [],
  previewModal: true
})

const presets = new Configuration({
  default: {
    attachments: true,
    code: {
      tabSize: 2
    },
    markdown: true,
    multiLine: true,
    permittedAttachmentTypes: null,
    richText: true,
    toolbar: {
      upload: "both"
    },
    headings: [ "h2", "h3", "h4" ],
    highlight: {
      buttons: {
        color: range(1, 9).map(n => `var(--highlight-${n})`),
        "background-color": range(1, 9).map(n => `var(--highlight-bg-${n})`),
      },
      permit: {
        color: [],
        "background-color": []
      }
    }
  }
})

export default {
  global,
  presets,
  configure({ global: newGlobal, ...newPresets }) {
    if (newGlobal) {
      global.merge(newGlobal)
    }
    presets.merge(newPresets)
  }
}
